export default `
mutation DeleteShiftTemplate($templateId: ID!) {
  deleteShiftTemplate(templateId: $templateId) {
    templateId
    displayName
    userId
    propertyId
    time {
      duration
      startHours
      startMinutes
    }
    note
    requiredLevels
    serviceProviderId
    timezone
  }
}
`;